import { render, staticRenderFns } from "./RelationOrder.vue?vue&type=template&id=77d2666c&scoped=true&"
import script from "./RelationOrder.vue?vue&type=script&lang=js&"
export * from "./RelationOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d2666c",
  null
  
)

export default component.exports